import Vue from 'vue';
import FastClick from 'fastclick';
import { CONNECT } from '@/app.config';
import App from './App.vue';
import router from './router';
import store from './store/store';
import i18n from './locales/i18n';
import ApiService from './services/api.service';

import './libs/vant';
import './libs/veeValidate';
import './utils/console.utils';
import './design/didor.scss';

// Inicializamos nuesta API
const appMode = localStorage.getItem('appMode') || 'DEV';
const apiUrl =
  process.env.NODE_ENV === 'production' ? CONNECT.PROD.API_URL : CONNECT[appMode].API_URL;

ApiService.init(apiUrl, CONNECT.API_VERSION);

Vue.config.productionTip = false;

FastClick.attach(document.body);

FastClick.prototype.focus = targetElement => {
  targetElement.focus();
};

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
